import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer'

const C = {
  primary: '#2563eb',
  primaryDark: '#1d4ed8',
  red: '#dc2626',
  green: '#16a34a',
  purple: '#7c3aed',
  text: '#111827',
  muted: '#6b7280',
  border: '#e5e7eb',
  bg: '#f9fafb',
  white: '#ffffff',
}

const s = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 10,
    color: C.text,
    backgroundColor: C.white,
    paddingBottom: 44,
  },

  // ── Header ──────────────────────────────
  header: {
    backgroundColor: C.primary,
    paddingHorizontal: 32,
    paddingVertical: 18,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerBrand: { color: C.white },
  headerBrandName: { fontSize: 18, fontFamily: 'Helvetica-Bold', letterSpacing: 1 },
  headerBrandSub: { fontSize: 8, color: 'rgba(255,255,255,0.7)', marginTop: 2 },
  headerRight: { alignItems: 'flex-end', color: C.white },
  headerTitle: { fontSize: 14, fontFamily: 'Helvetica-Bold', color: C.white },
  headerDate: { fontSize: 8, color: 'rgba(255,255,255,0.7)', marginTop: 3 },

  // ── Body ────────────────────────────────
  body: { paddingHorizontal: 32, paddingTop: 24 },
  section: { marginBottom: 22 },
  sectionTitle: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: C.muted,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    marginBottom: 10,
    paddingBottom: 6,
    borderBottomWidth: 1,
    borderBottomColor: C.border,
  },

  // ── Veículo ─────────────────────────────
  vehicleRow: { flexDirection: 'row', gap: 20 },
  vehiclePhoto: { width: 180, height: 130, borderRadius: 6, objectFit: 'cover' },
  vehiclePhotoBox: {
    width: 180, height: 130, borderRadius: 6,
    backgroundColor: C.bg, borderWidth: 1, borderColor: C.border,
    alignItems: 'center', justifyContent: 'center',
  },
  vehiclePhotoText: { fontSize: 9, color: C.muted },
  vehicleInfo: { flex: 1 },
  vehiclePlate: { fontSize: 26, fontFamily: 'Helvetica-Bold', letterSpacing: 3, color: C.text },
  vehicleModel: { fontSize: 13, color: C.text, marginTop: 4 },
  vehicleTags: { flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 10 },
  vehicleTag: {
    backgroundColor: C.bg, borderRadius: 4,
    paddingHorizontal: 8, paddingVertical: 4,
    borderWidth: 1, borderColor: C.border,
  },
  vehicleTagLabel: { fontSize: 7, color: C.muted, textTransform: 'uppercase', letterSpacing: 0.4 },
  vehicleTagValue: { fontSize: 10, fontFamily: 'Helvetica-Bold', color: C.text, marginTop: 2 },

  // ── Resumo / destaque ───────────────────
  heroBox: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#dbeafe',
    backgroundColor: '#eff6ff',
    padding: 18,
  },
  heroLabel: {
    fontSize: 9,
    color: C.primaryDark,
    textTransform: 'uppercase',
    letterSpacing: 0.8,
    fontFamily: 'Helvetica-Bold',
  },
  heroValue: {
    marginTop: 8,
    fontSize: 28,
    color: C.primaryDark,
    fontFamily: 'Helvetica-Bold',
  },
  heroSub: {
    marginTop: 6,
    fontSize: 9,
    color: C.muted,
    lineHeight: 1.4,
  },
  heroMetaRow: {
    flexDirection: 'row',
    gap: 10,
    marginTop: 14,
  },
  heroMetaCard: {
    flex: 1,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: C.border,
    backgroundColor: C.white,
    paddingHorizontal: 10,
    paddingVertical: 8,
  },
  heroMetaLabel: {
    fontSize: 7,
    color: C.muted,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
  heroMetaValue: {
    marginTop: 4,
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: C.text,
  },

  // ── Financeiro ──────────────────────────
  finTable: {
    borderWidth: 1, borderColor: C.border, borderRadius: 8, overflow: 'hidden',
  },
  finRow: {
    flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
    paddingHorizontal: 16, paddingVertical: 10,
    borderBottomWidth: 1, borderBottomColor: C.border,
  },
  finLabel: { fontSize: 10, color: C.text },
  finLabelMuted: { fontSize: 9, color: C.muted },
  finValue: { fontSize: 13, fontFamily: 'Helvetica-Bold' },
  ofertaRow: {
    flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
    backgroundColor: C.primary,
    paddingHorizontal: 16, paddingVertical: 14,
  },
  ofertaLeft: {},
  ofertaLabel: { fontSize: 12, fontFamily: 'Helvetica-Bold', color: C.white },
  ofertaPct: { fontSize: 8, color: 'rgba(255,255,255,0.7)', marginTop: 3 },
  ofertaValue: { fontSize: 20, fontFamily: 'Helvetica-Bold', color: C.white },

  // ── Reparos ─────────────────────────────
  repairCard: {
    flexDirection: 'row',
    borderWidth: 1, borderColor: C.border, borderRadius: 8,
    marginBottom: 8, overflow: 'hidden',
  },
  repairPhoto: { width: 120, height: 120, objectFit: 'cover' },
  repairPhotoBox: {
    width: 120, height: 120,
    backgroundColor: C.bg,
    alignItems: 'center', justifyContent: 'center',
  },
  repairPhotoText: { fontSize: 8, color: C.muted },
  repairBody: { flex: 1, padding: 10, justifyContent: 'space-between' },
  repairHeader: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' },
  repairNameBlock: { flex: 1, marginRight: 8 },
  repairName: { fontSize: 11, fontFamily: 'Helvetica-Bold', color: C.text },
  repairCategory: { fontSize: 8, color: C.muted, marginTop: 2 },
  repairCostBadge: {
    backgroundColor: C.red, borderRadius: 4,
    paddingHorizontal: 7, paddingVertical: 3,
  },
  repairCostText: { fontSize: 10, fontFamily: 'Helvetica-Bold', color: C.white },
  repairObs: { fontSize: 8, color: C.muted, marginTop: 6 },
  repairObsLabel: { fontFamily: 'Helvetica-Bold' },

  // ── Sem reparos ─────────────────────────
  noRepairs: {
    borderWidth: 1, borderColor: C.border, borderRadius: 8,
    paddingVertical: 20, alignItems: 'center',
  },
  noRepairsText: { fontSize: 10, color: C.muted },

  // ── Observações ─────────────────────────
  obsBox: {
    borderWidth: 1, borderColor: C.border, borderRadius: 8,
    padding: 12, backgroundColor: C.bg,
  },
  obsText: { fontSize: 10, color: C.text, lineHeight: 1.5 },

  evidenceSummary: {
    borderWidth: 1,
    borderColor: '#fee2e2',
    borderRadius: 8,
    backgroundColor: '#fef2f2',
    paddingHorizontal: 12,
    paddingVertical: 10,
    marginBottom: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  evidenceSummaryText: { fontSize: 9, color: C.text, fontFamily: 'Helvetica-Bold' },

  // ── Assinatura ──────────────────────────
  signatureBox: {
    borderWidth: 1,
    borderColor: C.border,
    borderRadius: 8,
    padding: 14,
    backgroundColor: C.bg,
  },
  signatureText: { fontSize: 9, color: C.text, lineHeight: 1.45 },
  signatureMeta: {
    marginTop: 12,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  signatureMetaItem: {
    borderWidth: 1,
    borderColor: C.border,
    borderRadius: 5,
    backgroundColor: C.white,
    paddingHorizontal: 8,
    paddingVertical: 6,
  },
  signatureMetaLabel: { fontSize: 7, color: C.muted, textTransform: 'uppercase' },
  signatureMetaValue: { marginTop: 3, fontSize: 9, color: C.text, fontFamily: 'Helvetica-Bold' },
  signatureImageWrap: {
    marginTop: 16,
    borderWidth: 1,
    borderColor: C.border,
    borderRadius: 6,
    backgroundColor: C.white,
    padding: 10,
  },
  signatureImage: { height: 72, objectFit: 'contain' },
  signatureLine: {
    borderTopWidth: 1,
    borderTopColor: C.text,
    marginTop: 8,
    paddingTop: 5,
    alignItems: 'center',
  },
  signatureLineText: { fontSize: 8, color: C.muted },

  // ── Footer ──────────────────────────────
  footer: {
    position: 'absolute', bottom: 0, left: 0, right: 0,
    paddingHorizontal: 32, paddingVertical: 11,
    borderTopWidth: 1, borderTopColor: C.border,
    flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
    backgroundColor: C.white,
  },
  footerText: { fontSize: 8, color: C.muted },
})

// ── Helpers ──────────────────────────────────────────────

const fmt = (v: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v)

const fmtPct = (ofertado: number, fipe: number) => {
  if (!fipe || !ofertado) return ''
  const pct = ((ofertado - fipe) / fipe) * 100
  return `${pct > 0 ? '+' : ''}${pct.toFixed(1)}% do FIPE`
}

const hoje = () =>
  new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })


// ── Tipos ────────────────────────────────────────────────

export interface RepairoPDF {
  nome: string
  categoria: string
  custo: number
  observacoes?: string
  fotoUrl?: string
}

export interface AssinaturaPDF {
  nome: string
  documento?: string
  telefone?: string
  imagemUrl: string
  emitidaEm: string
}

export interface PropostaPDFProps {
  placa: string
  marca: string
  modelo: string
  ano: number
  anoModelo?: string
  cor?: string
  combustivel?: string
  cambio?: string
  quilometragem?: number
  motor?: string
  portas?: number
  fotoPrincipalUrl?: string
  notaFinal?: number
  valorFIPE: number
  custoReparos: number
  valorLiquido: number
  margemLucro: number
  valorOfertado: number
  reparos: RepairoPDF[]
  observacoes?: string
  assinatura?: AssinaturaPDF
  /** Se true, esconde todas as seções financeiras (FIPE, oferta, margem, custo). */
  modoOficina?: boolean
  documentoTipo?: 'compra' | 'consignacao' | 'oficina'
  consignacao?: {
    valorAnunciado: number
    comissaoLoja: string
    prazoConsignacao: string
    condicoes?: string
  }
}

// ── Componente ───────────────────────────────────────────

const PropostaPDF = (props: PropostaPDFProps) => {
  const {
    placa, marca, modelo, ano, anoModelo, cor, combustivel, cambio, quilometragem, motor, portas, fotoPrincipalUrl, notaFinal,
    valorFIPE, custoReparos, valorLiquido, valorOfertado,
    reparos, observacoes, assinatura, modoOficina = false, documentoTipo, consignacao,
  } = props

  const tipoDocumento = documentoTipo ?? (modoOficina ? 'oficina' : 'compra')
  const isConsignacao = tipoDocumento === 'consignacao'
  const isOficina = tipoDocumento === 'oficina'
  const headerSubtitle = isOficina ? 'Documentação de Entrada' : isConsignacao ? 'Termo Comercial' : 'Sistema de Avaliação 360°'
  const headerTitlePage1 = isOficina ? 'TERMO DE ENTRADA DE VEÍCULO' : isConsignacao ? 'TERMO DE CONSIGNAÇÃO' : 'PROPOSTA DE COMPRA'
  const headerTitlePage2 = isOficina ? 'ITENS DOCUMENTADOS' : isConsignacao ? 'AVALIAÇÃO ANEXA' : 'REPAROS IDENTIFICADOS'
  const reparosSectionTitle = isOficina
    ? `Itens Críticos Documentados (${reparos.length} ${reparos.length === 1 ? 'item' : 'itens'})`
    : isConsignacao
      ? `Pontos Documentados na Avaliação (${reparos.length} ${reparos.length === 1 ? 'item' : 'itens'})`
      : `Reparos Identificados (${reparos.length} ${reparos.length === 1 ? 'item' : 'itens'})`
  const noRepairsText = isOficina
    ? 'Nenhum item crítico identificado'
    : isConsignacao
      ? 'Nenhum ponto crítico documentado na avaliação'
      : 'Nenhum reparo identificado — veículo em bom estado'
  const footerText = isOficina ? 'WeAuto · Documentação de Entrada' : isConsignacao ? 'WeAuto · Termo de Consignação' : 'WeAuto · Proposta de Compra'

  return (
    <Document title={`${headerTitlePage1} - ${placa}`} author="WeAuto">
      <Page size="A4" style={s.page}>

        {/* ── Header ─────────────────────────── */}
        <View style={s.header}>
          <View style={s.headerBrand}>
            <Text style={s.headerBrandName}>WeAuto</Text>
            <Text style={s.headerBrandSub}>{headerSubtitle}</Text>
          </View>
          <View style={s.headerRight}>
            <Text style={s.headerTitle}>{headerTitlePage1}</Text>
            <Text style={s.headerDate}>{hoje()}</Text>
          </View>
        </View>

        <View style={s.body}>

          {/* ── Veículo ──────────────────────── */}
          <View style={s.section}>
            <Text style={s.sectionTitle}>Veículo</Text>
            <View style={s.vehicleRow}>
              {fotoPrincipalUrl ? (
                <Image src={fotoPrincipalUrl} style={s.vehiclePhoto} />
              ) : (
                <View style={s.vehiclePhotoBox}>
                  <Text style={s.vehiclePhotoText}>Sem foto</Text>
                </View>
              )}
              <View style={s.vehicleInfo}>
                <Text style={s.vehiclePlate}>{placa}</Text>
                <Text style={s.vehicleModel}>{marca} {modelo}</Text>
                <View style={s.vehicleTags}>
                  <View style={s.vehicleTag}>
                    <Text style={s.vehicleTagLabel}>Ano</Text>
                    <Text style={s.vehicleTagValue}>{ano}</Text>
                  </View>
                  {anoModelo && (
                    <View style={s.vehicleTag}>
                      <Text style={s.vehicleTagLabel}>Ano modelo</Text>
                      <Text style={s.vehicleTagValue}>{anoModelo}</Text>
                    </View>
                  )}
                  {cor && (
                    <View style={s.vehicleTag}>
                      <Text style={s.vehicleTagLabel}>Cor</Text>
                      <Text style={s.vehicleTagValue}>{cor}</Text>
                    </View>
                  )}
                  {combustivel && (
                    <View style={s.vehicleTag}>
                      <Text style={s.vehicleTagLabel}>Combustível</Text>
                      <Text style={s.vehicleTagValue}>{combustivel}</Text>
                    </View>
                  )}
                  {cambio && (
                    <View style={s.vehicleTag}>
                      <Text style={s.vehicleTagLabel}>Câmbio</Text>
                      <Text style={s.vehicleTagValue}>{cambio}</Text>
                    </View>
                  )}
                  {quilometragem && (
                    <View style={s.vehicleTag}>
                      <Text style={s.vehicleTagLabel}>Quilometragem</Text>
                      <Text style={s.vehicleTagValue}>
                        {quilometragem.toLocaleString('pt-BR')} km
                      </Text>
                    </View>
                  )}
                  {motor && (
                    <View style={s.vehicleTag}>
                      <Text style={s.vehicleTagLabel}>Motor</Text>
                      <Text style={s.vehicleTagValue}>{motor}</Text>
                    </View>
                  )}
                  {portas ? (
                    <View style={s.vehicleTag}>
                      <Text style={s.vehicleTagLabel}>Portas</Text>
                      <Text style={s.vehicleTagValue}>{portas}</Text>
                    </View>
                  ) : null}
                  {notaFinal && (
                    <View style={s.vehicleTag}>
                      <Text style={s.vehicleTagLabel}>Nota da Avaliação</Text>
                      <Text style={s.vehicleTagValue}>{notaFinal.toFixed(1)} / 10</Text>
                    </View>
                  )}
                </View>
              </View>
            </View>
          </View>

          {!isOficina && !isConsignacao && (
            <View style={s.section}>
              <Text style={s.sectionTitle}>Resumo Comercial / Fechamento</Text>
              <View style={s.heroBox}>
                <Text style={s.heroLabel}>Valor final do fechamento</Text>
                <Text style={s.heroValue}>{fmt(valorOfertado)}</Text>
                <Text style={s.heroSub}>
                  Fechamento calculado com base no valor FIPE, nos reparos identificados e no valor definido pela loja.
                </Text>
                <View style={s.heroMetaRow}>
                  <View style={s.heroMetaCard}>
                    <Text style={s.heroMetaLabel}>FIPE</Text>
                    <Text style={s.heroMetaValue}>{fmt(valorFIPE)}</Text>
                  </View>
                  <View style={s.heroMetaCard}>
                    <Text style={s.heroMetaLabel}>Reparos</Text>
                    <Text style={s.heroMetaValue}>{fmt(custoReparos)}</Text>
                  </View>
                </View>
              </View>
            </View>
          )}

          {isConsignacao && consignacao && (
            <View style={s.section}>
              <Text style={s.sectionTitle}>Condições da Consignação</Text>
              <View style={s.heroBox}>
                <Text style={s.heroLabel}>Valor anunciado</Text>
                <Text style={s.heroValue}>{fmt(consignacao.valorAnunciado)}</Text>
                <Text style={s.heroSub}>
                  Termo para registrar as condições comerciais combinadas entre a loja e o proprietário do veículo.
                </Text>
                <View style={s.heroMetaRow}>
                  <View style={s.heroMetaCard}>
                    <Text style={s.heroMetaLabel}>Comissão da loja</Text>
                    <Text style={s.heroMetaValue}>{consignacao.comissaoLoja}</Text>
                  </View>
                  <View style={s.heroMetaCard}>
                    <Text style={s.heroMetaLabel}>Prazo</Text>
                    <Text style={s.heroMetaValue}>{consignacao.prazoConsignacao}</Text>
                  </View>
                </View>
              </View>
            </View>
          )}

          {isConsignacao && consignacao?.condicoes ? (
            <View style={s.section}>
              <Text style={s.sectionTitle}>Observações / Condições</Text>
              <View style={s.obsBox}>
                <Text style={s.obsText}>{consignacao.condicoes}</Text>
              </View>
            </View>
          ) : null}

          {/* ── Financeiro ───────────────────── */}
          {!isOficina && !isConsignacao && (
            <View style={s.section}>
              <Text style={s.sectionTitle}>Estrutura da Oferta</Text>
              <View style={s.finTable}>
                <View style={s.finRow}>
                  <Text style={s.finLabel}>Valor FIPE (Tabela)</Text>
                  <Text style={[s.finValue, { color: C.primary }]}>{fmt(valorFIPE)}</Text>
                </View>
                <View style={s.finRow}>
                  <Text style={s.finLabel}>(-) Custo de Reparos</Text>
                  <Text style={[s.finValue, { color: C.red }]}>{fmt(custoReparos)}</Text>
                </View>
                <View style={s.finRow}>
                  <Text style={s.finLabel}>(=) Valor Líquido Sugerido</Text>
                  <Text style={[s.finValue, { color: C.green }]}>{fmt(valorLiquido)}</Text>
                </View>
                <View style={s.ofertaRow}>
                  <View style={s.ofertaLeft}>
                    <Text style={s.ofertaLabel}>OFERTA FINAL</Text>
                    <Text style={s.ofertaPct}>{fmtPct(valorOfertado, valorFIPE)}</Text>
                  </View>
                  <Text style={s.ofertaValue}>{fmt(valorOfertado)}</Text>
                </View>
              </View>
            </View>
          )}

        </View>

        <View style={s.footer} fixed>
          <Text style={s.footerText}>{footerText}</Text>
          <Text style={s.footerText}>
            Documento gerado em {hoje()} · {placa} — {marca} {modelo} {ano}
          </Text>
        </View>

      </Page>

      <Page size="A4" style={s.page}>
        <View style={s.header}>
          <View style={s.headerBrand}>
            <Text style={s.headerBrandName}>WeAuto</Text>
            <Text style={s.headerBrandSub}>{headerSubtitle}</Text>
          </View>
          <View style={s.headerRight}>
            <Text style={s.headerTitle}>{headerTitlePage2}</Text>
            <Text style={s.headerDate}>{hoje()}</Text>
          </View>
        </View>

        <View style={s.body}>

          {/* ── Reparos ──────────────────────── */}
          <View style={s.section}>
            <Text style={s.sectionTitle}>{reparosSectionTitle}</Text>
            {!isOficina && !isConsignacao && (
              <View style={s.evidenceSummary}>
                <Text style={s.evidenceSummaryText}>
                  Custo total estimado de reparos
                </Text>
                <Text style={[s.finValue, { color: C.red }]}>{fmt(custoReparos)}</Text>
              </View>
            )}
            {reparos.length === 0 ? (
              <View style={s.noRepairs}>
                <Text style={s.noRepairsText}>{noRepairsText}</Text>
              </View>
            ) : (
              reparos.map((r, i) => (
                <View key={i} style={s.repairCard}>
                  {r.fotoUrl ? (
                    <Image src={r.fotoUrl} style={s.repairPhoto} />
                  ) : (
                    <View style={s.repairPhotoBox}>
                      <Text style={s.repairPhotoText}>Sem foto</Text>
                    </View>
                  )}
                  <View style={s.repairBody}>
                    <View style={s.repairHeader}>
                      <View style={s.repairNameBlock}>
                        <Text style={s.repairName}>{r.nome}</Text>
                        {r.categoria ? (
                          <Text style={s.repairCategory}>{r.categoria}</Text>
                        ) : null}
                      </View>
                      {!isOficina && !isConsignacao && (
                        <View style={s.repairCostBadge}>
                          <Text style={s.repairCostText}>{fmt(r.custo)}</Text>
                        </View>
                      )}
                    </View>
                    {r.observacoes ? (
                      <Text style={s.repairObs}>
                        <Text style={s.repairObsLabel}>Obs: </Text>
                        {r.observacoes}
                      </Text>
                    ) : null}
                  </View>
                </View>
              ))
            )}
          </View>

          {observacoes ? (
            <View style={s.section}>
              <Text style={s.sectionTitle}>Observações Gerais</Text>
              <View style={s.obsBox}>
                <Text style={s.obsText}>{observacoes}</Text>
              </View>
            </View>
          ) : null}

          {assinatura ? (
            <View style={s.section}>
              <Text style={s.sectionTitle}>Termo de Ciência das Condições do Veículo</Text>
              <View style={s.signatureBox}>
                <Text style={s.signatureText}>
                  {isConsignacao
                    ? 'Declaro que recebi, conferi e estou ciente das condições de consignação descritas neste documento, incluindo valor anunciado, comissão, prazo, fotos, pontos documentados e observações da avaliação.'
                    : 'Declaro que recebi, conferi e estou ciente das condições do veículo descritas neste documento, incluindo fotos, reparos identificados, pontos de atenção e observações registradas na avaliação.'}
                </Text>
                <View style={s.signatureMeta}>
                  <View style={s.signatureMetaItem}>
                    <Text style={s.signatureMetaLabel}>Nome</Text>
                    <Text style={s.signatureMetaValue}>{assinatura.nome}</Text>
                  </View>
                  {assinatura.documento ? (
                    <View style={s.signatureMetaItem}>
                      <Text style={s.signatureMetaLabel}>CPF/CNPJ</Text>
                      <Text style={s.signatureMetaValue}>{assinatura.documento}</Text>
                    </View>
                  ) : null}
                  {assinatura.telefone ? (
                    <View style={s.signatureMetaItem}>
                      <Text style={s.signatureMetaLabel}>Telefone</Text>
                      <Text style={s.signatureMetaValue}>{assinatura.telefone}</Text>
                    </View>
                  ) : null}
                  <View style={s.signatureMetaItem}>
                    <Text style={s.signatureMetaLabel}>Data e hora</Text>
                    <Text style={s.signatureMetaValue}>{assinatura.emitidaEm}</Text>
                  </View>
                </View>
                <View style={s.signatureImageWrap}>
                  <Image src={assinatura.imagemUrl} style={s.signatureImage} />
                  <View style={s.signatureLine}>
                    <Text style={s.signatureLineText}>Assinatura de ciência</Text>
                  </View>
                </View>
              </View>
            </View>
          ) : null}

        </View>

        <View style={s.footer} fixed>
          <Text style={s.footerText}>{footerText}</Text>
          <Text style={s.footerText}>
            Documento gerado em {hoje()} · {placa} — {marca} {modelo} {ano}
          </Text>
        </View>

      </Page>

    </Document>
  )
}

export default PropostaPDF
